import { createAsyncThunk } from "@reduxjs/toolkit";
import type { AxiosError, AxiosRequestConfig } from "axios";
import { CategoryService } from "../../../services/CategoryService";
import { CategoryInterface } from "../../../entities/Category";

export const fetchCategories = createAsyncThunk<
  CategoryInterface[],
  AxiosRequestConfig,
  { rejectValue: AxiosError }
>(
  "category/fetchCategories",
  async (params: AxiosRequestConfig, { rejectWithValue }) => {
    try {
      const response = await CategoryService.getCategories(params);
      const { data } = response;

      return data;
    } catch (e: any) {
      return rejectWithValue(e.message as AxiosError);
    }
  },
);
